import React, { Fragment } from 'react';
import { Route, Redirect } from 'react-router-dom';
const PrivateRoute = ({ isLoggedIn, title, component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      component={props =>
        isLoggedIn ? (
          <Fragment>
            <Component {...props} title={title} />
          </Fragment>
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default PrivateRoute;
